import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import type { TariffByModalTab } from 'reactApp/ui/TariffsModal/TariffsModalContent.types';

export const useGetProductsByTab = (tariffs: TariffByModalTab[], activeTab: ETabsName) => {
    return tariffs.map((tariff) => {
        const { products } = tariff;

        const isMonthProduct = activeTab === ETabsName.month && products?.monthProduct;

        let product = isMonthProduct ? products.monthProduct : products.yearProduct;

        if (!product) {
            product = Object.values(products).filter(Boolean)[0];
        }

        return product.id;
    });
};
